import React from "react";
import Navbar from "./Navbar";
// import Icons from "./Icons";
import Getintouch from "./Getintouch";
import Subscribe from "./Subscribe";
import Footer from "./Footer";


const Contact = () => {
  return (
    <>
      <Navbar />
      <Getintouch />
      <Subscribe />
      <Footer />
    </>
  );
};

export default Contact;
